import { FC } from 'react';

type Props = {
  link: string;
  label: string;
};

const ReturnButton: FC<Props> = ({ link, label }) => {
  return (
    <div className="absolute xxl:fixed py-2 lg:py-4 px-1 lg:px-5 top-[54px] lg:top-0 xxl:top-[64px] left-1/2 -translate-x-1/2 max-w-10xl w-full pointer-events-none z-50">
      <a
        href={link}
        className="group w-fit text-sm md:text-tiny lg:text-base flex gap-2 lg:gap-3 justify-center items-center py-1 md:py-2 lg:py-3 px-2 md:px-5 font-icb rounded-md bg-blue700 text-white pointer-events-auto hover-darken-blue"
      >
        <img
          src="/Images/Icons/Arrows/arrow-right-white.svg"
          alt="arrow"
          width="20"
          height="20"
          className="w-5 max-h-[1.2rem] rotate-180 lg:group-hover:-translate-x-1 transition duration-200"
        />
        {label}
      </a>
    </div>
  );
};

export default ReturnButton;
